import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserModel } from '../models/person/user.model';
import {Configuration} from "../../assets/Configuration";
import { ManageUserModel } from '../models/person/manage-user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  public getUserByPersonId(personId: string): Observable<UserModel> {
    const params = new HttpParams()
      .set('personId', personId);
    
    return this.httpClient.get<UserModel>(
      Configuration.getApiBaseUrl() + "/user/by-person-id", 
      { params: params }
    );
  }

  public provisionUserAccess(personId: string): Observable<UserModel | null> {
    return this.httpClient.post<UserModel | null>(
      Configuration.getApiBaseUrl() + `/user/${personId}/provision-access`,
      null
    );
  }

  public changeUserPasswordByPersonId(manageUserModel: ManageUserModel): Observable<UserModel> {
    return this.httpClient.post<UserModel>(Configuration.getApiBaseUrl() + "/user/change-password", manageUserModel);
  }

  public registerMissingAccounts(roleId: string): Observable<void> {
    return this.httpClient.post<void>(Configuration.getApiBaseUrl() + "/user/register-missing-users-by-role/" + roleId, {});
  }

  public isCreateMissingUsersRunning(): Observable<{ isRunning: boolean }> {
    return this.httpClient.get<{ isRunning: boolean }>(
      Configuration.getApiBaseUrl() + "/user/register-missing-users-by-role/status"
    );
  }

  public getWbdConfigured(): Observable<boolean> {
    return this.httpClient.get<boolean>(Configuration.getApiBaseUrl() + "/Wbd/configured");
  }  
}
